import loader from '../../common/loader';
import cookie from '../../common/cookie';
import miloRequest from '../../common/network';
import ATM from '../../util/atm';
import { getGameId } from '../login/common'; // 微信JSSDK add by weiztang 微信接口开放改造

var jsApi = 'https://unpkg.byted-static.com/bridge/douyin_open/1.0.10/lib/douyin_open.umd.js'; // const qqAppid = '';
// const wxAppid = '';

var loginFuncsTips = 'Please use LoginManager,exec from jsBridge is not effect.';
var miloSelfConfig = {
  isMiloWayCookies: true,
  appName: 'douyin'
}; // 加载wxjssdk，活动开发可以自行指定版本号

var loadJsApi = function loadJsApi(jsApiCustom) {
  return new Promise(function (resolve, reject) {
    var loadJsApiUrl = jsApiCustom || jsApi;
    console.log('loadJsApiURL', loadJsApiUrl); // 如果有wx全局变量且有wx.config初始化方法 weiztang

    if (window.DouyinOpenJSBridge && window.DouyinOpenJSBridge.config) {
      // console.log('window.DouyinOpenJSBridge', window.DouyinOpenJSBridge);
      resolve(window.DouyinOpenJSBridge);
      return;
    }

    loader.loadScript(loadJsApiUrl).then(function (isLoad) {
      if (isLoad && window.DouyinOpenJSBridge) {
        // console.log('window.DouyinOpenJSBridge', window.DouyinOpenJSBridge);
        resolve(window.DouyinOpenJSBridge);
      } else {
        reject();
      }
    })["catch"](function (e) {
      reject(e);
    });
  });
}; // 请求微信JSAPI库，并使用签名环境初始化，注意回调需要在微信客户端环境，模拟UA无效


var initConfig = function initConfig(opt, sign, callback) {
  console.log('initConfig');
};
/*
// 使用demo：
import {
    miloJsBridge
} from '@tencent/milo-core'

console.log(miloJsBridge.getJsBridge().getSignature({
    'sAppId': 'wxf8773b4d31a9a719', // 指定的wxappid
    'callback':function(res){
        console.log('callback',res)
    }
}))
 */


var getSignature = function getSignature(opt) {
  console.log('getSignature');
};

var loginByQQAndWX = function loginByQQAndWX() {
  console.log(loginFuncsTips);
};

var loginByWX = function loginByWX() {
  console.log(loginFuncsTips);
};

var loginByQQ = function loginByQQ() {
  console.log(loginFuncsTips);
};

var setAppCookie = function setAppCookie() {
  return new Promise(function (resolve) {
    console.log(loginFuncsTips);
    resolve();
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    // 这里是是APP登录态是否特殊处理的开关之一
    resolve(null);
  });
};

var logout = function logout() {
  console.log(loginFuncsTips);
};

var wechat = {
  // 不开放方法，请使用LoginManager
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  // jssdk相关方法
  loadJsApi: loadJsApi,
  getSignature: getSignature,
  initConfig: initConfig,
  miloSelfConfig: miloSelfConfig
};
export default wechat;